<template>
  <div v-if="location.show">
    <GmapMarker :position="position" :ref="location.id" :clickable="true" @click="handleClick()" :icon="markerIcon" />
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data: () => ({
    markers: {
      start: 'https://alabama-travel.s3.amazonaws.com/v3/images/map/Road+Trip+Pin+Start.svg',
      end: 'https://alabama-travel.s3.amazonaws.com/v3/images/map/Road+Trip+Pin+End.svg',
      default: 'https://alabama-travel.s3.amazonaws.com/v3/images/experiences/map-pins/ex-map-pin-px.svg',
    },
  }),
})
class MapPin extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  location;

  @Prop({
    type: Boolean,
    required: true,
  })
  show;


  mounted() {
    const self = this;
    this.$store.subscribe((mutation, state) => {
      if (!self.$refs) {
        return;
      }
      switch (mutation.type) {
        case 'maps/setSelectedLocation':
          if (
            self.$refs &&
            !state.maps.hoveredLocation &&
            state.maps.previousSelection
          ) {
            const activePinRef = self.$refs[state.maps.previousSelection.id];
            if (activePinRef && activePinRef.$markerObject) {
              activePinRef.$markerObject.setIcon(
                this.markerIcon.replace('px-active.svg', 'px.svg'),
              );
            }
            break;
          }
          if (
            self.$refs &&
            state.maps.hoveredLocation &&
            state.maps.hoveredLocation.id &&
            self.$refs[state.maps.hoveredLocation.id]
          ) {
            const activePinRef = self.$refs[state.maps.hoveredLocation.id];
            activePinRef.$markerObject.setIcon(
              this.markerIcon.replace('px.svg', 'px-active.svg'),
            );
          }
          break;
        case 'maps/setHoveredLocation':
          if (
            self.$refs &&
            state.maps.hoveredLocation &&
            state.maps.hoveredLocation.id &&
            self.$refs[state.maps.hoveredLocation.id]
          ) {
            const pinRef = self.$refs[state.maps.hoveredLocation.id];
            pinRef.$markerObject.setIcon(
              this.markerIcon.replace('px.svg', 'px-active.svg'),
            );
          }
          break;
        default:
      }
    });
  }


  async handleClick() {
    await this.$store.dispatch('maps/setSelectedLocation', this.location);
  }

  async handleMouseOver() {
    this.$store.dispatch('maps/setHoveredLocation', this.location);
  }

  async handleMouseOut() {
    this.$store.dispatch('maps/setHoveredLocation', null);
  }

  get position() {
    return {
      lat: Number(this.location.latitude ? this.location.latitude : this.location.position.lat),
      lng: Number(this.location.longitude ? this.location.longitude : this.location.position.lng),
    };
  }

  get markerIcon() {
    if (this.location.dest) {
      return this.markers.end;
    }
    if (this.location.begin) {
      return this.markers.start;
    }
    return this.markers.default;
  }
}
export default MapPin;
</script>

<style></style>
